import { HDialog } from "@components/Dialog"
import { Input } from "@components/Input"
import { HTextArea } from "@components/Input/HTextArea"
import { FormControl, Grid } from "@mui/material"
import { LabelControl } from "@shared/styledComponents"

export const ComplainDetailForm = ({ title, isOpen, data, handleOnClose }: any) => {
    return (
        <HDialog
            PaperProps={{
                sx: {
                    width: "750px",
                    maxWidth: "750px",
                }
            }}
            title={title}
            open={isOpen}
            handleClose={handleOnClose}
            dialogFooter={
                <>
                </>
            }
        >
            <Grid container>
                <Grid sx={{ pt: 0, pl: 0 }} item xs={12}>
                    <FormControl disabled sx={{ width: '100%' }} variant="standard">
                        <LabelControl>Tên khách hàng</LabelControl>
                        <Input disabled value={data.CustomerName} />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl disabled sx={{ width: '100%' }} variant="standard">
                        <LabelControl>Số điện thoại</LabelControl>
                        <Input disabled value={data.CustomerPhoneNumber} />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl disabled sx={{ width: '100%' }} variant="standard">
                        <LabelControl>Hạng khách hàng</LabelControl>
                        <Input disabled value={data.CustomerMemberShipClass || 'Standard'} />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl disabled sx={{ width: '100%' }} variant="standard">
                        <LabelControl>Tiêu đề</LabelControl>
                        <Input disabled value={data.Title} />
                    </FormControl>
                </Grid>
                <Grid sx={{ pt: 0, pl: 0, marginTop: '16px' }} item xs={12}>
                    <FormControl disabled sx={{ width: '100%' }} variant="standard">
                        <LabelControl>Nội dung khiếu nại</LabelControl>
                        <HTextArea
                            disabled
                            defaultValue={data.Content || ""}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </HDialog>
    )
}